import {
  Uc2BindingType,
  Uc2Direction,
  Uc2FaultClass,
  Uc2PressureRole,
  Uc2Stage,
  Uc2State,
} from '#models';

export type Uc2StageStatus = 'done' | 'current' | 'pending' | 'skipped';

export interface Uc2StageView {
  stage: Uc2Stage;
  label: string;
  status: Uc2StageStatus;
  detail: string;
}

export interface Uc2SignalContextEntry {
  label: string;
  value: string;
}

export interface Uc2SignalTimelineRow {
  exceptionId: string;
  asset: string;
  signalClass: string;
  startMs: number;
  endMs: number;
  intervals?: [number, number][];
  detectedMs: number;
  context: Uc2SignalContextEntry[];
}

export const UC2_STAGE_LABELS: Record<Uc2Stage, string> = {
  [Uc2Stage.Detection]: 'Detection',
  [Uc2Stage.AnalystDecision]: 'Analyst decision',
  [Uc2Stage.EngineerDecision]: 'Engineer decision',
  [Uc2Stage.DispatchVerify]: 'Dispatch & verify',
  [Uc2Stage.Closed]: 'Closed',
};

export const UC2_STATE_LABELS: Record<Uc2State, string> = {
  [Uc2State.Detected]: 'Detected',
  [Uc2State.Assigned]: 'Assigned',
  [Uc2State.UnderAnalystReview]: 'Under analyst review',
  [Uc2State.AwaitingEngineerApproval]: 'Awaiting engineer approval',
  [Uc2State.AgreedResolutionRecorded]: 'Agreed resolution recorded',
  [Uc2State.Dispatch]: 'Dispatch',
  [Uc2State.Verify]: 'Verify',
  [Uc2State.End]: 'Closed',
  [Uc2State.Dismissed]: 'Dismissed',
};

export const UC2_FAULT_CLASS_LABELS: Record<Uc2FaultClass, string> = {
  [Uc2FaultClass.LiftGasStarvation]: 'Lift-gas starvation',
  [Uc2FaultClass.InflowIssue]: 'Inflow issue',
  [Uc2FaultClass.OutflowIssue]: 'Outflow issue',
  [Uc2FaultClass.Undetermined]: 'Undetermined',
};

export const UC2_BINDING_LABELS: Record<Uc2BindingType, string> = {
  [Uc2BindingType.SharedGasLiftSupply]: 'Shared gas-lift supply',
  [Uc2BindingType.SharedFlowPath]: 'Shared flow path',
  [Uc2BindingType.SharedJacket]: 'Shared jacket',
  [Uc2BindingType.SharedEquipment]: 'Shared equipment',
};

export const UC2_PRESSURE_ROLE_LABELS: Record<Uc2PressureRole, string> = {
  [Uc2PressureRole.CasingHead]: 'Casing head',
  [Uc2PressureRole.WellHead]: 'Well head',
  [Uc2PressureRole.Tubing]: 'Tubing',
  [Uc2PressureRole.FlowLine]: 'Flow line',
};

export const UC2_DIRECTION_LABELS: Record<Uc2Direction, string> = {
  [Uc2Direction.Drop]: 'Drop',
  [Uc2Direction.Rise]: 'Rise',
};

/** End is not closed until a typed recovery record exists, so it must not read as "Closed". */
export function uc2StateLabel(state: Uc2State, hasRecovery: boolean): string {
  if (state === Uc2State.End && !hasRecovery) {
    return 'Awaiting recovery record';
  }
  return UC2_STATE_LABELS[state];
}
